import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Circoli from "@/pages/Circoli";
import Galleria from "@/pages/Galleria";
import GalleriaGiornata from "@/pages/GalleriaGiornata";
import Modulistica from "@/pages/Modulistica";
import Regolamento from "@/pages/Regolamento";
import RassegnaStampa from "@/pages/RassegnaStampa";
import GiustiziaSportiva from "@/pages/GiustiziaSportiva";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/circoli" element={<Circoli />} />
          <Route path="/galleria" element={<Galleria />} />
          <Route path="/galleria/giornata/:n" element={<GalleriaGiornata />} />
          <Route path="/modulistica" element={<Modulistica />} />
          <Route path="/regolamento" element={<Regolamento />} />
          <Route path="/rassegna-stampa" element={<RassegnaStampa />} />
          <Route path="/giustizia-sportiva" element={<GiustiziaSportiva />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="top-center" />
    </div>
  );
}

export default App;
